import type { ForgeResponse } from '../../types.tsx';

/**
 * This function deduplicates issueGlances if and only if there is an issueContext that shares the same installationId.
 * This would happen if both jira:issueContext and jira:issueGlance modules are defined in the same manifest.yml file for a forge app,
 * and solves the issue of having both a glance and context panel appear for the same app.
 * @param forgeData required to iterate through issueGlance and issueContext
 * @returns the same ForgeResponse object
 */
export const dedupeContextAndGlance = (forgeData: ForgeResponse): ForgeResponse => {
	const contextInstallationIds = new Set(
		forgeData.issueContext?.map(({ installationId }) => installationId),
	);
	const newGlanceItems = forgeData.issueGlance.filter(
		({ installationId }) => !contextInstallationIds.has(installationId),
	);

	return {
		...forgeData,
		issueGlance: newGlanceItems,
	};
};
